import http from '../../../plugins/axios';

export default {

    listWalletAccount(){
        return http.get({
            url : '/admin/wallet/list'
        })
    },

    removeWalletAccount(data) {
        return http.post({
            url : '/admin/wallet/remove',
            data,
            dataType: 'form'
        })
    },

    updateWalletAccount(data) {
        return http.post({
            url: '/admin/wallet/update',
            data,
        })
    },

    createWalletAccount(data) {
        return http.post({
            url : '/admin/wallet/create',
            data,
        })
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
}